import { defineMessages } from 'react-intl';

const messages = defineMessages({
  services: { id: 'Services', defaultMessage: 'Services' },
  addService: { id: 'addService', defaultMessage: 'Add service URL' },
  title: { id: 'Title', defaultMessage: 'Title' },
  subtitle: { id: 'Subtitle', defaultMessage: 'Subtitle' },
  serviceUrlsDescription: {
    id: 'serviceUrlsDescription',
    defaultMessage:
      'Enter the URLs of the services that will be displayed, one per line. Use the https:// format.',
  },
});

export const servicesSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.services),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'subtitle', 'serviceUrls'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
    },
    subtitle: {
      title: intl.formatMessage(messages.subtitle),
    },
    serviceUrls: {
      title: intl.formatMessage(messages.services),
      description: intl.formatMessage(messages.serviceUrlsDescription),
      type: 'array',
      widget: 'array_list',
      items: {
        type: 'list',
        properties: {
          url: {
            title: intl.formatMessage(messages.addService),
            type: 'string',
            widget: 'url',
          },
        },
        required: ['url'],
      },
    },
  },
  required: ['serviceUrls'],
});
